/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { builderProfileBuildersActions } from "./gen/creators.js";

/** Actions for the BuilderProfile document model */

export const actions = { ...baseActions, ...builderProfileBuildersActions };
